import * as UI from "@iyk/ui"

export type TextFieldProps = Omit<UI.Textbox.Props, "type"> & {
  type: "text" | "email" | "datetime-local"
  label?: React.ReactNode
  labelDescription?: React.ReactNode
  optionalMessage?: React.ReactNode
  validationMessage?: string
  name: string
  wrapperClassName?: string
  affix?: {
    type: "prefix" | "suffix"
    text: React.ReactNode
  }
}

export const TextField = ({
  label,
  labelDescription,
  optionalMessage = <span className="text-gray-11">(Optional)</span>,
  name,
  validationMessage,
  required,
  affix,
  wrapperClassName,
  ...props
}: TextFieldProps) => {
  const isOptional = !required

  return (
    <UI.Field
      name={name}
      validationMessage={validationMessage}
      required={required}
      className={wrapperClassName}
    >
      {label && (
        <UI.Label description={labelDescription}>
          {label} {isOptional && optionalMessage}
        </UI.Label>
      )}
      {affix ? (
        <UI.TextboxAffix type={affix.type} text={affix.text}>
          <UI.Textbox {...props} />
        </UI.TextboxAffix>
      ) : (
        <UI.Textbox {...props} />
      )}

      <UI.Validity />
    </UI.Field>
  )
}
